export class RateOverride {
    id: number;
    name: string;
    prefix_starts_with: number;
    retail_cost_per_minute: number;
    retail_connection_charge: number;
    wholesale_cost_per_minute_less_than: number;
    wholesale_connection_charge_less_than: number;
}
